import doc                      from '@widesk-core/decorators/doc';
import model                    from '@widesk-core/decorators/model';
import NetworkServiceModel      from '@/models/NetworkServiceModel';
import RelationStatusModel      from './RelationStatus';

@model.urnResource('relation')
@doc.path('/relations/{?id}')
export default class RelationModel extends NetworkServiceModel {
	private declare _tsFilters: {
		"id": id;
	};

	private declare _tsSorts: {
		'createdAt': string;
		'id': string;
		'updatedAt': string;
	};

	@doc.model(RelationStatusModel) declare relationStatus: RelationStatusModel;
}